
import React from 'react'
import './Imagesecond.css'

const Imagesecond = () => {
  return (
    <>
   <div className="photo">
    <img src="https://cb.scene7.com/is/image/Crate/cb_dHP_20230713_DesignDeskV2?wid=1440&qlt=80&op_sharpen=1" alt="" />
    {/* <img src="https://cb.scene7.com/is/image/Crate/CB_20230713_HP_FallDecor1?wid=1440&qlt=80&op_sharpen=1" alt=""/> */}
   </div>

   <div className="photo2">
   <img src="https://cb.scene7.com/is/image/Crate/CB_20230713_HP_Bedding2Left1?wid=720&qlt=80&op_sharpen=1" alt="" />
   <img src="https://cb.scene7.com/is/image/Crate/CB_20230713_HP_Bedding2Right1?wid=720&qlt=80" alt="" />
   </div>

   <div className="photo">
   <img src="https://cb.scene7.com/is/image/Crate/CB_20230713_HP_Dining1?wid=1440&qlt=80&op_sharpen=1" alt="" />
   </div>

   <div className="photo3">
   <img src="https://cb.scene7.com/is/image/Crate/CB_20230713_HP_KitchenElec1?wid=1440&qlt=80&op_sharpen=1" alt="" />
   <img src="https://cb.scene7.com/is/image/Crate/cb_dHP_20230713_HomeReno2?wid=1440&qlt=80&op_sharpen=1" alt="" />
   </div>
   </>
  )
}

export default Imagesecond